import React from "react";
import DocumentDetail from "../common/DocumentDetail";
import { BLANK_PLACEHOLDER } from "config/constant";
import { RECEIVE_OFFICIAL_LETTER_FIELD as FIELD } from "config/documentConstant";
import { DocumentDtoWithAny } from "models/document/DocumentDtoWithAny";
import { Text } from "@react-pdf/renderer";

interface ReceiveOfficialLetterDetailProps {
  documentData: DocumentDtoWithAny["documentData"];
}

const ReceiveOfficialLetterDetail = ({
  documentData,
}: ReceiveOfficialLetterDetailProps) => {
  return (
    <>
      <DocumentDetail.Section>
        <DocumentDetail.Field label={FIELD.DOCUMENT_RECEIPT_NUMBER.label}>
          <Text
            style={{
              fontFamily: "Pretendard",
              fontSize: "10pt",
            }}
          >
            {documentData[FIELD.DOCUMENT_RECEIPT_NUMBER.key] ||
              BLANK_PLACEHOLDER}
          </Text>
        </DocumentDetail.Field>

        <DocumentDetail.Field label={FIELD.SENDER.label}>
          <Text
            style={{
              fontFamily: "Pretendard",
              fontSize: "10pt",
            }}
          >
            {documentData[FIELD.SENDER.key] || BLANK_PLACEHOLDER}
          </Text>
        </DocumentDetail.Field>

        <DocumentDetail.Field label={FIELD.REGISTRATION_DATE.label}>
          <DocumentDetail.Value.Date>
            <Text
              style={{
                fontFamily: "Pretendard",
                fontSize: "10pt",
              }}
            >
              {documentData[FIELD.REGISTRATION_DATE.key] || BLANK_PLACEHOLDER}
            </Text>
          </DocumentDetail.Value.Date>
        </DocumentDetail.Field>

        <DocumentDetail.Field label={FIELD.TITLE.label}>
          <Text
            style={{
              fontFamily: "Pretendard",
              fontSize: "10pt",
            }}
          >
            {documentData[FIELD.TITLE.key] || BLANK_PLACEHOLDER}
          </Text>
        </DocumentDetail.Field>
      </DocumentDetail.Section>
    </>
  );
};

export default ReceiveOfficialLetterDetail;
